<template>
  <div
    v-loading.fullscreen.lock="isSubmitting"
    :element-loading-text="$t('Submitting...')"
    class="company-profile-form-page page-content">
    <el-row class="page-header -with-back-button" type="flex" justify="space-between">
      <el-col :span="24">
        <el-button
          type="text"
           icon="el-icon-back"
           class="back-button"
           @click.prevent="backToCompanyProfileList">
        </el-button>
        <h2 class="page-title" v-if="isUpdated">แก้ไขข้อมูลบริษัทสำหรับรับชำระ</h2>
        <h2 class="page-title" v-else>เพิ่มข้อมูลบริษัทสำหรับรับชำระใหม่</h2>
      </el-col>
    </el-row>

    <el-form
      :model="profileForm"
      :rules="profileFormRules"
      ref="profileForm"
      label-width="120px"
      label-position="top"
      @submit.native.prevent="submitForm('profileForm')"
      :disabled="isSubmitting"
      class="profile-form profile-detail-info detail-form">
      <el-row class="detail-section">
        <el-row>
          <el-col :span="24">
            <h3 class="section-title">ข้อมูลบริษัทสำหรับรับชำระ</h3>
          </el-col>
        </el-row>
        <el-row class="detail-row">
          <el-row>
            <el-col :span="9">
              <el-form-item label="ชื่อบริษัท" prop="name">
                <el-input
                  v-model="profileForm.name"
                  id="profileForm.name"
                  :maxlength="50"
                  placeholder="กรอกชื่อข้อมูลบริษัทสำหรับรับชำระ"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
      </el-row>

      <el-row class="detail-section">
        <el-row>
          <el-col :span="24">
            <h3 class="section-title">ที่อยู่บริษัท <sup class="required">**</sup></h3>
          </el-col>
        </el-row>
        <el-row class="detail-row">
          <el-row>
            <el-col :span="9">
              <el-form-item label="" prop="use_company_address">
                <el-checkbox
                  v-model="profileForm.use_company_address"
                  @change="toggleUsingCompanyAddress"
                  id="profileForm.use_company_address">ใช้ที่อยู่เดียวกับรายละเอียดหลักของบริษัท</el-checkbox>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
        <el-row class="detail-row">
          <el-row>
            <el-col :span="9">
              <el-form-item label="ที่อยู่" prop="address.line_1">
                <el-input
                  v-model="profileForm.address.line_1"
                  :disabled="profileForm.use_company_address"
                  id="profileForm.address.line_1"
                  placeholder="กรอกที่อยู่"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
        <el-row class="detail-row">
          <el-row>
            <el-col :span="9">
              <el-form-item label="ตำบล/แขวง" prop="address.district">
                <el-input
                  v-model="profileForm.address.district"
                  :disabled="profileForm.use_company_address"
                  id="profileForm.address.district"
                  placeholder="กรอกตำบล/แขวง"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="9" :offset="1">
              <el-form-item label="อำเภอ/เขต" prop="address.city">
                <el-input
                  v-model="profileForm.address.city"
                  :disabled="profileForm.use_company_address"
                  id="profileForm.address.city"
                  placeholder="กรอกอำเภอ/เขต"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
        <el-row class="detail-row">
          <el-row>
            <el-col :span="9">
              <el-form-item label="จังหวัด" prop="address.province">
                <el-select
                  v-model="profileForm.address.province"
                  :disabled="profileForm.use_company_address"
                  id="profileForm.address.province">
                  <el-option
                    v-for="province in provinceList"
                    :key="province"
                    :label="province"
                    :value="province">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="9" :offset="1">
              <el-form-item label="รหัสไปรษณีย์" prop="address.postal_code">
                <el-input
                  v-model="profileForm.address.postal_code"
                  :disabled="profileForm.use_company_address"
                  id="profileForm.address.postal_code"
                  @change="updatePostCode"
                  ref="profileForm.address.postal_code"
                  @input.native="handleInput($event, 'profileForm.address.postal_code', 'postcode')"
                  placeholder="กรอกรหัสไปรษณีย์"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="9">
              <el-form-item label="โทรศัพท์" prop="address.tel">
                <el-input
                  v-model="profileForm.address.tel"
                  :disabled="profileForm.use_company_address"
                  id="profileForm.address.tel"
                  placeholder="กรอกโทรศัพท์"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="9" :offset="1">
              <el-form-item label="โทรสาร" prop="address.fax">
                <el-input
                  v-model="profileForm.address.fax"
                  :disabled="profileForm.use_company_address"
                  id="profileForm.address.fax"
                  placeholder="กรอกโทรสาร"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
      </el-row>

      <el-row class="detail-section">
        <el-row>
          <el-col :span="11">
            <h3 class="section-title">Bill Payment <sup class="required">**</sup></h3>
          </el-col>
          <el-col :span="12">
            <h3 class="section-title">Cross Bank Bill Payment <sup class="required">**</sup></h3>
          </el-col>
        </el-row>
        <el-row class="detail-row">
          <el-row>
            <el-col :span="6">
              <el-form-item
                label=""
                prop="bill_payment_account_no"
                ref="bill_payment_account_no">
                <el-checkbox
                  v-model="profileForm.use_bill_payment_account_no"
                  @change="toggleUsingAccountNo"
                  id="profileForm.use_bill_payment_account_no">หมายเลขบัญชี</el-checkbox>
                <el-input
                  v-model="profileForm.bill_payment_account_no"
                  :disabled="!profileForm.use_bill_payment_account_no"
                  id="profileForm.bill_payment_account_no"
                  @change="updateMaskAccountNo"
                  ref="profileForm.bill_payment_account_no"
                  @input.native="handleInput($event, 'profileForm.bill_payment_account_no', 'accountNo')"
                  placeholder="หมายเลขบัญชี"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3" :offset="1">
              <el-form-item
                label=""
                prop="bill_payment_comp_code"
                ref="bill_payment_comp_code">
                <el-checkbox
                  v-model="profileForm.use_bill_payment_comp_code"
                  @change="toggleUsingCompCode"
                  id="profileForm.use_bill_payment_comp_code">COMP CODE</el-checkbox>
                <el-input
                  v-model="profileForm.bill_payment_comp_code"
                  :disabled="!profileForm.use_bill_payment_comp_code"
                  id="profileForm.bill_payment_comp_code"
                  ref="profileForm.bill_payment_comp_code"
                  @update="updateMaskCompCode"
                  @input.native="handleInput($event, 'profileForm.bill_payment_comp_code', 'compCode')"
                  placeholder="COMP CODE"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="6" :offset="1">
              <el-form-item
                label=""
                prop="bill_payment_biller_id"
                ref="bill_payment_biller_id">
                <el-checkbox
                  v-model="profileForm.use_bill_payment_biller_id"
                  @change="toggleUsingBillerId"
                  id="profileForm.use_bill_payment_biller_id">Biller ID</el-checkbox>
                <el-input
                  v-model="profileForm.bill_payment_biller_id"
                  :disabled="!profileForm.use_bill_payment_biller_id"
                  @keyup.native="changeBillPaymentBillerId"
                  ref="profileForm.bill_payment_biller_id"
                  @input.native="handleInput($event, 'profileForm.bill_payment_biller_id', 'billerId')"
                  id="profileForm.bill_payment_biller_id"
                  placeholder="Biller ID"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
      </el-row>

      <el-row class="detail-section">
        <el-row>
          <el-col :span="24">
            <h3 class="section-title">ข้อมูลสำหรับบาร์โค้ดและ QR code</h3>
          </el-col>
        </el-row>
        <el-row class="detail-row">
          <el-row>
            <el-col :span="9">
              <el-form-item
                label=""
                ref="barcode_qrcode_biller_id_tax_id"
                prop="barcode_qrcode_biller_id_tax_id">
                <el-radio
                  v-model="profileForm.barcode_qrcode_type"
                  label="biller_id"
                  @change="toggleUsingBarcodeQRcodeType"
                  id="profileForm.use_barcode_qrcode_biller_id_1">Biller ID</el-radio>
                <el-row>
                  <el-col :span="14">
                    <el-input
                      v-model="profileForm.barcode_qrcode_biller_id_tax_id"
                      :disabled="profileForm.barcode_qrcode_type !== 'biller_id'"
                      id="profileForm.barcode_qrcode_biller_id_tax_id"
                      ref="profileForm.barcode_qrcode_biller_id_tax_id"
                      @input.native="handleInput($event, 'profileForm.barcode_qrcode_biller_id_tax_id', 'qrBillerId')"
                      placeholder="Biller ID"></el-input>
                  </el-col>
                  <el-col :span="9" :offset="1">
                    <el-input
                      v-model="profileForm.barcode_qrcode_biller_id_suffix"
                      :minlength="2"
                      :maxlength="2"
                      :disabled="profileForm.barcode_qrcode_type !== 'biller_id'"
                      id="profileForm.barcode_qrcode_biller_id_suffix"
                      placeholder="Suffix 2 digits"></el-input>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
            <el-col :span="9" :offset="1">
              <el-form-item
                label=""
                ref="barcode_qrcode_account_no"
                prop="barcode_qrcode_account_no">
                <el-radio
                  v-model="profileForm.barcode_qrcode_type"
                  label="account_no"
                  :disabled="profileForm.use_bill_payment_biller_id"
                  @change="toggleUsingBarcodeQRcodeType"
                  id="profileForm.use_barcode_qrcode_biller_id_2">หมายเลขบัญชี</el-radio>
                <el-row>
                  <el-col :span="14">
                    <el-input
                      v-model="profileForm.barcode_qrcode_account_no"
                      :disabled="profileForm.barcode_qrcode_type === 'biller_id' || profileForm.use_bill_payment_biller_id"
                      id="profileForm.barcode_qrcode_account_no"
                      @change="updateMaskAccountNo"
                      ref="profileForm.barcode_qrcode_account_no"
                      @input.native="handleInput($event, 'profileForm.barcode_qrcode_account_no', 'accountNo')"
                      placeholder="หมายเลขบัญชี"></el-input>
                  </el-col>
                  <el-col :span="9" :offset="1">
                    <el-input
                      v-model="profileForm.barcode_qrcode_account_no_suffix"
                      :minlength="2"
                      :maxlength="2"
                      :disabled="profileForm.barcode_qrcode_type === 'biller_id' || profileForm.use_bill_payment_biller_id"
                      id="profileForm.barcode_qrcode_account_no_suffix"
                      placeholder="Suffix 2 digits"></el-input>
                  </el-col>
                </el-row>
                <div class="remark-red">**กรณีที่ใช้หมายเลขบัญชี จะไม่สามารถสร้าง QR Code ได้</div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
      </el-row>

      <el-row class="detail-section">
        <el-row>
          <el-col :span="24">
            <h3 class="section-title">Business Type</h3>
          </el-col>
        </el-row>
        <el-row class="detail-row">
          <el-col :span="6">
            <el-radio
              v-model="profileForm.business_type"
              label="B2C"
              @change="businessTypeChange"
              id="profileForm.business_type_b2c">B2C</el-radio>
          </el-col>
          <el-col :span="6">
            <el-radio
              v-model="profileForm.business_type"
              label="B2B"
              @change="businessTypeChange"
              id="profileForm.business_type_b2b">ธุรกิจ B2B</el-radio>
          </el-col>
          <el-col :span="6">
            <el-radio
              v-model="profileForm.business_type"
              label="EDU"
              @change="businessTypeChange"
              id="profileForm.business_type_edu">สถานศึกษา</el-radio>
          </el-col>
          <el-col :span="6">
            <el-radio
              v-model="profileForm.business_type"
              label="SPECIAL"
              @change="businessTypeChange"
              id="profileForm.business_type_special">ธุรกิจพิเศษ</el-radio>
            <el-form-item label="" prop="business_type_special_industry">
              <el-input
                v-model="profileForm.business_type_special_industry"
                :disabled="profileForm.business_type !== 'SPECIAL'"
                id="profileForm.business_type_special_industry"
                @blur="businessTypeChange"
                placeholder="สาขา"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-row>

      <el-row class="detail-section">
        <el-row>
          <el-col :span="24">
            <h3 class="section-title">วิธีการชำระเงิน  <sup class="required">**</sup></h3>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="9">
            <el-form-item label="" prop="payment_type">
              <el-radio
                v-model="profileForm.payment_type"
                label="CHEQUE_OR_CASH"
                id="profileForm.payment_type_cheque_cash">เช็ค/เงินสด</el-radio>
              <el-radio
                v-model="profileForm.payment_type"
                label="CASH_ONLY"
                id="profileForm.payment_type_cash_only">เงินสดอย่างเดียว</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
      </el-row>

      <el-row class="detail-section">
        <el-row>
          <el-col :span="24">
            <h3 class="section-title">Charge Type</h3>
          </el-col>
        </el-row>
        <el-row class="detail-row">
          <el-row>
            <el-col :span="9">
              <el-form-item label="" prop="charge_payer">
                <el-checkbox
                  v-model="profileForm.charge_payer"
                  @change="checkChargePayer"
                  id="profileForm.charge_payer">Charge Payer</el-checkbox>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="9">
              <el-form-item label="IB/IR" prop="ir_br">
                <el-input
                  v-model="profileForm.ir_br"
                  :disabled="!profileForm.charge_payer"
                  id="profileForm.ir_br"
                  placeholder="กรอก IB/IR"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
      </el-row>

      <el-row class="detail-section">
        <el-row>
          <el-col :span="24">
            <h3 class="section-title">Account Reference</h3>
          </el-col>
        </el-row>
        <el-row class="detail-row">
          <el-row>
            <el-col :span="9">
              <el-form-item label="ชื่อบัญชี" prop="account_name">
                <el-input
                  v-model="profileForm.account_name"
                  id="profileForm.account_name"
                  placeholder="กรอกชื่อบัญชี"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
        <el-row class="detail-row">
          <el-row>
            <el-col :span="9">
              <el-form-item label="Label (Ref. 1)" prop="label_ref1">
                <el-input
                  v-model="profileForm.label_ref1"
                  id="profileForm.label_ref1"
                  :maxlength="25"
                  placeholder="กรอกชื่อเรียก Reference No. 1"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="9" :offset="1">
              <el-form-item label="Label (Ref. 2)" prop="label_ref2">
                <el-input
                  v-model="profileForm.label_ref2"
                  id="profileForm.label_ref2"
                  :maxlength="25"
                  placeholder="กรอกชื่อเรียก Reference No. 2"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
      </el-row>

      <el-row class="detail-section">
        <el-row>
          <el-col :span="24">
            <h3 class="section-title">ข้อมูลบัญชีธนาคารอื่นๆที่จะปรากฎบน Pay-in Slip (สูงสุด 6 บัญชี)</h3>
          </el-col>
        </el-row>
        <el-row class="detail-row">
          <el-row>
            <el-col :span="9">
              <el-form-item label="" prop="allow_other_banks">
                <el-checkbox
                  v-model="profileForm.allow_other_banks"
                  id="profileForm.allow_other_banks">Admin ของบริษัทผู้ใช้งานสามารถเพิ่มข้อมูลด้วยตนเองได้</el-checkbox>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="profileForm.allow_other_banks && profileForm.other_banks.length > 0">
            <el-col :span="12">
              <h4>รายการข้อมูลบัญชีธนาคารอื่นๆ</h4>
              <div class="other-bank-list">
                <div class="other-bank-info" v-for="(bankInfo, idx) in profileForm.other_banks" :key="idx">
                  <div class="other-bank-logo-holder">
                    <img :src="bankInfo.account_logo" v-if="bankInfo.account_logo">
                  </div>
                  <div class="other-bank-text-holder">
                    {{ bankInfo.account_name.trim() !== '' ? getOtherBankInfoSummaryText(bankInfo) : '-' }}
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-row>
      </el-row>

      <el-row class="detail-section">
        <el-row>
          <el-col :span="24">
            <!-- <h3 class="section-title">การแจ้งเตือน</h3> -->
              <el-form-item label="" prop="is_banking_agent">
                <el-checkbox
                  v-model="profileForm.is_banking_agent"
                  id="profileForm.is_banking_agent"><h3 class="section-title">ตัวแทนธนาคาร (Banking agent)</h3></el-checkbox>
              </el-form-item>
          </el-col>
        </el-row>
      </el-row>

      <el-row class="detail-section">
        <el-row>
          <el-col :span="24">
            <h3 class="section-title">การแจ้งเตือน</h3>
          </el-col>
        </el-row>
        <el-row class="detail-row">
          <el-col :span="24">
            <el-form-item
              label=""
              ref="notification_msg"
              prop="notification_msg">
              <el-row>
                <el-col :span="24">
                  <el-radio
                    v-model="profileForm.notification_msg_type"
                    label="DATE"
                    @change="toggleUsingNotificationMsgValue"
                    id="profileForm.notification_msg_type_1">
                    <el-row>
                      <el-col :span="8">กรุณาชำระภายในวันที่</el-col>
                      <el-col :span="5" :offset="1">
                        <el-select
                          v-model="profileForm.notification_msg_date"
                          :disabled="profileForm.notification_msg_type === 'CUSTOM'"
                          @change="toggleUsingNotificationMsgValue"
                          style="width:100px;text-align:center;"
                          id="profileForm.notification_msg_date">
                          <el-option
                            v-for="day in notificationDayList"
                            :key="day"
                            :label="day"
                            :value="day">
                          </el-option>
                        </el-select>
                      </el-col>
                      <el-col :span="5" :offset="1">
                        ของทุกเดือน
                      </el-col>
                    </el-row>
                  </el-radio>
                </el-col>
              </el-row>
              <el-row style="margin-top: 20px;">
                <el-col :span="24">
                  <el-radio
                    v-model="profileForm.notification_msg_type"
                    label="CUSTOM"
                    @change="toggleUsingNotificationMsgValue"
                    id="profileForm.notification_msg_type_2">
                    _
                  </el-radio>
                  <el-input
                    v-model="profileForm.notification_msg_custom"
                    :disabled="profileForm.notification_msg_type !== 'CUSTOM'"
                    id="profileForm.notification_msg_custom"
                    style="width:300px;"
                    :maxlength="100"
                    placeholder="กรอกข้อความแจ้งเตือนที่ต้องการ"></el-input>
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
        </el-row>
      </el-row>

      <el-row class="detail-section">
        <el-row>
          <el-col :span="24">
            <h3 class="section-title">ตัวเลือกในการพิมพ์</h3>
          </el-col>
        </el-row>
        <el-row class="detail-row">
          <el-row class="logo-uploader-holder">
            <el-col :span="24">
              <el-form-item label="โลโก้บริษัท" prop="logo">
                <div class="logo-holder" v-if="profileForm.logo">
                  <img :src="profileForm.logo" class="logo"/>
                </div>
                <el-upload
                  class="company-logo-uploader"
                  :action="uploadUrl"
                  drag
                  :show-file-list="false"
                  :http-request="handleHttpRequest"
                  :on-success="handleLogoSuccess"
                  :on-error="handleLogoFail"
                  :before-upload="beforeLogoUpload">
                  <div class="upload-instruction" v-loading="isUploading">
                    <h3>อัพโหลดโลโก้บริษัท</h3>
                    <i class="el-icon-upload logo-uploader-icon"></i>
                  </div>
                </el-upload>
                <div class="upload-instruction-hint">
                  ขนาดขั้นต่ำ 500px x 500px และต้องเป็นไฟล์นามสกุล JPG, PNG, GIF
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- <el-row>
            <el-col :span="9">
              <el-form-item label="เลือกตัวเลือกในการพิมพ์" prop="printing_option">
                <el-radio
                  v-model="profileForm.printing_option"
                  label="COLOR"
                  id="profileForm.printing_option_color">พิมพ์สี</el-radio>
                <el-radio
                  v-model="profileForm.printing_option"
                  label="BLACK_AND_WHITE"
                  id="profileForm.printing_option_bw">พิมพ์ขาวดำ</el-radio>
              </el-form-item>
            </el-col>
          </el-row> -->
        </el-row>
      </el-row>

      <el-row>
        <el-col :span="18">
          <el-form-item class="button-bar">
            <el-button
              type="primary"
              plain
              class="cancel-btn"
              @click="backToCompanyProfileList"
              id="profileForm.cancelButton">{{ 'Cancel' | translate }}</el-button>
            <div class="submit-button-group">
              <el-button
                type="danger"
                class="terminate-btn"
                icon="el-icon-delete"
                v-if="isUpdated"
                @click="confirmTerminate"
                id="profileForm.terminateButton">{{ 'Terminate' | translate }}</el-button>
              <el-button
                type="primary"
                id="profileForm.submitButton"
                icon="el-icon-edit"
                native-type="submit">{{ 'Save and continue' | translate }}</el-button>
            </div>
          </el-form-item>
        </el-col>
      </el-row>

    </el-form>
  </div>
</template>

<script>
  /* eslint no-param-reassign: 0 */
  import helpers from '@/libs/helpers';
  import { createMask } from 'imask';
  import _ from 'lodash';
  import XRegExp from 'xregexp';

  /**
   * Company Profile Form view
   */
  const CompanyProfileFormView = {
    name: 'company-profile-form',
    props: ['companyId', 'profileId'],
    data() {
      return {
        isSubmitting: false,
        isUploading: false,
        isSetupUpdateData: false,
        dayList: [],
        profileFormRules: {
          name: [
            { required: true, max: 50, message: 'กรุณากรอกชื่อบริษัท', trigger: 'blur' },
          ],
          'address.line_1': [
            { required: true, message: 'กรุณากรอกที่อยู่บริษัท', trigger: 'blur' },
          ],
          'address.district': [
            { required: true, message: 'กรุณากรอกตำบล/แขวง', trigger: 'blur' },
          ],
          'address.city': [
            { required: true, message: 'กรุณากรอกอำเภอ/เขต', trigger: 'blur' },
          ],
          'address.province': [
            { required: true, message: 'กรุณาเลือกจังหวัด', trigger: 'blur' },
          ],
          'address.postal_code': [
            { required: true, min: 5, message: 'กรุณากรอกรหัสไปรษณีย์', trigger: 'blur' },
          ],
          'address.tel': [
            { required: true, message: 'กรุณากรอกหมายเลขโทรศัพท์', trigger: 'blur' },
            // { type: 'string',
            // pattern: new XRegExp('^02-\\d{3}-\\d{4}$|^0[3-5|7]
            // \\d{1}-\\d{3}-\\d{3}$|^0[6|8|9]\\d{1}-\\d{3}-\\d{4}$', 'g'),
            // message: 'กรุณากรอกหมายเลขโทรศัพท์ให้ตรงรูปแบบ', trigger: 'blur' },
          ],
          'address.fax': [
            { message: 'กรุณากรอกหมายเลขโทรสาร', trigger: 'blur' },
            // { type: 'string',
            // pattern: new XRegExp('^02-\\d{3}-\\d{4}$|^0[3-5|7]\\d{1}-\\d{3}-\\d{3}$', 'g'),
            // message: 'กรุณากรอกหมายเลขโทรสารให้ตรงรูปแบบ', trigger: 'blur' },
          ],
          bill_payment_comp_code: [
            { validator: this.checkBillPaymentFields, message: 'กรุณาเลือกอย่างน้อย 1 รายการ', trigger: 'blur' },
            { validator: this.checkBillPaymentCompCode, message: 'กรุณากรอก COMP CODE', trigger: 'blur' },
          ],
          bill_payment_account_no: [
            { validator: this.checkBillPaymentFields, message: 'กรุณาเลือกอย่างน้อย 1 รายการ', trigger: 'blur' },
            { validator: this.checkBillPaymentAccountNo, message: 'กรุณากรอกหมายเลขบัญชี', trigger: 'blur,change' },
          ],
          bill_payment_biller_id: [
            { validator: this.checkBillPaymentFields, message: 'กรุณาเลือกอย่างน้อย 1 รายการ', trigger: 'blur' },
            { validator: this.checkBillPaymentBillerId, message: 'กรุณากรอก Biller ID จำนวน 15 หลัก', trigger: 'blur' },
          ],
          barcode_qrcode_biller_id_tax_id: [
            { validator: this.checkBarcodeQRCodeBillerId, message: 'กรุณากรอก Biller ID จำนวน 13 หลัก และ Suffix 2 หลัก', trigger: 'blur' },
          ],
          barcode_qrcode_account_no: [
            { validator: this.checkBarcodeQRCodeAccountNo, message: 'กรุณากรอกหมายเลขบัญชี และ Suffix 2 หลัก', trigger: 'blur,change' },
          ],
          ir_br: [
            { validator: this.checkIBIR, message: 'กรุณากรอก IB/IR', trigger: 'blur' },
          ],
          account_name: [
            { required: true, message: 'กรุณาชื่อบัญชี', trigger: 'blur' },
          ],
          label_ref1: [
            { max: 25, message: 'กรุณากรอกชื่อเรียก Reference No. 1', trigger: 'blur' },
          ],
          label_ref2: [
            { max: 25, message: 'กรุณากรอกชื่อเรียก Reference No. 2', trigger: 'blur' },
          ],
          notification_msg: [
            { validator: this.checkNotificationMsg, max: 100, message: 'กรุณากรอกข้อความแจ้งเตือน', trigger: 'blur' },
          ],
          business_type_special_industry: [
            { validator: this.checkBusinessType, message: 'กรุณากรอกสาขาธุรกิจ', trigger: 'change,blur' },
          ],
        },
        profileForm: {
          id: null,
          name: '',
          use_company_address: true,
          address: {
            line_1: '',
            district: '',
            city: '',
            province: '',
            postal_code: '',
            tel: '',
            fax: '',
          },
          use_bill_payment_comp_code: false,
          bill_payment_comp_code: '',
          use_bill_payment_account_no: false,
          bill_payment_account_no: '',
          use_bill_payment_biller_id: true,
          bill_payment_biller_id: '',
          barcode_qrcode_type: 'biller_id',
          barcode_qrcode_biller_id_tax_id: '',
          barcode_qrcode_biller_id_suffix: '',
          barcode_qrcode_account_no: '',
          barcode_qrcode_account_no_suffix: '',
          payment_type: 'CHEQUE_OR_CASH', // "CHEQUE_OR_CASH", "CASH_ONLY"
          charge_payer: false,
          ir_br: '',
          account_name: '',
          label_ref1: '',
          label_ref2: '',
          label_ref3: '',
          allow_other_banks: true,
          is_banking_agent: false,
          other_banks: [],
          notification_msg_type: 'CUSTOM', // DATE or CUSTOM
          notification_msg_date: '1',
          notification_msg_custom: '',
          notification_msg: '',
          logo: '',
          printing_option: 'COLOR', // "COLOR", "BLACK_AND_WHITE"
          business_type: 'B2C',
          business_type_special_industry: null,
        },
        mask: {
          compCode: {
            mask: /^\d{0,4}$/,
          },
          accountNo: {
            mask: '000-0-00000-0',
          },
          billerId: {
            /* mask: [
              { mask: '0000000000' },
              { mask: '0000000000000' },
            ], */
            mask: /^\d{0,15}$/,
          },
          postcode: {
            mask: '00000',
          },
          telMask: [
            { mask: '{02}-000-0000' },
            { mask: '{0}00-000-000' },
            { mask: '{0}00-000-0000' },
          ],
          faxMask: [
            { mask: '{02}-000-0000' },
            { mask: '{0}00-000-000' },
          ],
          ibirMask: {
            mask: /^\d+\/\d+$/,
          },
          qrBillerId: {
            mask: /^\d{0,13}$/,
          },
          suffix: {
            mask: '00',
          },
        },
      };
    },
    computed: {
      isAuthenticated() {
        return this.$store.getters.idToken;
      },
      isUpdated() {
        return typeof this.companyId !== 'undefined' && typeof this.profileId !== 'undefined';
      },
      company() {
        return this.$store.getters.currentCompany;
      },
      profile() {
        return this.$store.getters.currentCompanyProfile;
      },
      uploadUrl() {
        return `${process.env.CLOUDINARY_API_BASE_URL}${window.appConfig.CLOUDINARY_CLOUD_NAME}/upload`;
      },
      provinceList() {
        return helpers.getProvinceList();
      },
      notificationDayList() {
        return this.dayList;
      },
    },
    methods: {
      backToCompanyProfileList() {
        const params = {
          companyId: this.companyId,
        };
        this.$router.push({ name: 'CompanyProfileList', params });
      },
      populateAddressFromCompany(isCopy) {
        if (isCopy) {
          Object.keys(this.company.address).forEach((key) => {
            const val = isCopy ? this.company.address[key] : '';
            this.$set(this.profileForm.address, key, val);
          });
        }
        /* if (isCopy) {
          this.$set(this.profileForm.address, 'tel', this.company.address.tel);
          this.$set(this.profileForm.address, 'fax', this.company.address.fax);
        } */
        this.updatePostCode();
      },
      toggleUsingCompanyAddress() {
        this.populateAddressFromCompany(this.profileForm.use_company_address);
      },
      handleBillPaymentData() {
        if (this.profileForm.use_bill_payment_biller_id) {
          this.$refs.profileForm.validateField('bill_payment_biller_id');
        } else {
          // this.profileForm.bill_payment_biller_id = '';
          this.$refs.bill_payment_biller_id.resetField();
        }
        if (this.profileForm.use_bill_payment_comp_code) {
          this.$refs.profileForm.validateField('bill_payment_comp_code');
        } else {
          // this.profileForm.bill_payment_comp_code = '';
          this.$refs.bill_payment_comp_code.resetField();
        }
        if (this.profileForm.use_bill_payment_account_no) {
          this.$refs.profileForm.validateField('bill_payment_account_no');
        } else {
          // this.profileForm.bill_payment_account_no = '';
          this.$refs.bill_payment_account_no.resetField();
          // this.$refs.bill_payment_account_no.resetField();
        }
        if (!this.profileForm.use_bill_payment_comp_code &&
          !this.profileForm.use_bill_payment_account_no &&
          !this.profileForm.use_bill_payment_biller_id) {
          this.$refs.profileForm.validateField('bill_payment_biller_id');
          this.$refs.profileForm.validateField('bill_payment_comp_code');
          this.$refs.profileForm.validateField('bill_payment_account_no');
        }
      },
      toggleUsingCompCode() {
        this.handleBillPaymentData();
      },
      toggleUsingAccountNo() {
        this.handleBillPaymentData();
      },
      toggleUsingBillerId() {
        this.handleBillPaymentData();
        if (this.profileForm.use_bill_payment_biller_id) {
          this.profileForm.barcode_qrcode_type = 'biller_id';
          this.changeBillPaymentBillerId();
        }
      },
      toggleUsingBarcodeQRcodeType() {
        if (this.profileForm.barcode_qrcode_type === 'biller_id') {
          this.profileForm.barcode_qrcode_account_no = '';
          this.profileForm.barcode_qrcode_account_no_suffix = '';
        } else {
          this.profileForm.barcode_qrcode_biller_id_tax_id = '';
          this.profileForm.barcode_qrcode_biller_id_suffix = '';
        }
        this.$refs.profileForm.validateField('barcode_qrcode_biller_id_tax_id');
        this.$refs.profileForm.validateField('barcode_qrcode_account_no');
      },
      changeBillPaymentBillerId() {
        if (this.profileForm.barcode_qrcode_type === 'biller_id') {
          if (this.profileForm.use_bill_payment_biller_id) {
            // update paired biller_id
            const billerId = this.profileForm.bill_payment_biller_id;
            if (billerId && billerId.length >= 15) {
              const qrBillerId = billerId.substr(0, 13);
              const suffix = billerId.substring(13, 15);
              this.profileForm.barcode_qrcode_biller_id_tax_id = qrBillerId;
              this.profileForm.barcode_qrcode_biller_id_suffix = suffix;
              // validate qrcode biller_id
              this.$refs.profileForm.validateField('barcode_qrcode_biller_id_tax_id');
              // update format
              this.updateMaskBillerId();
            } else {
              this.profileForm.barcode_qrcode_biller_id_tax_id = billerId;
            }
          }
          // this.profileForm.barcode_qrcode_account_no = '';
          this.profileForm.barcode_qrcode_account_no_suffix = '';
          this.$refs.barcode_qrcode_account_no.resetField();
          // this.$refs.barcode_qrcode_account_no_suffix.resetField();
        } else {
          // this.profileForm.barcode_qrcode_biller_id_tax_id = '';
          this.profileForm.barcode_qrcode_biller_id_suffix = '';
          this.$refs.barcode_qrcode_biller_id_tax_id.resetField();
          // this.$refs.barcode_qrcode_biller_id_suffix.resetField();
        }
        this.updateMaskBillerId();
      },
      checkBillerID(rule, value, cb) {
        let len = 0;
        if (value) {
          len = value.toString().length;
        }
        if (len !== 15) {
          cb(new Error('Biller ID must be 15 digits'));
        }
        cb();
      },
      checkBillPaymentFields(rule, value, cb) {
        // check at least one of 'bill_payment_comp_code',
        // 'bill_payment_account_no', 'bill_payment_biller_id'
        if (!this.profileForm.use_bill_payment_comp_code &&
          !this.profileForm.use_bill_payment_account_no &&
          !this.profileForm.use_bill_payment_biller_id) {
          cb(new Error('required bill payment information'));
        } else {
          cb();
        }
      },
      checkBillPaymentCompCode(rule, value, cb) {
        if (this.profileForm.use_bill_payment_comp_code &&
          (this.profileForm.bill_payment_comp_code === null ||
            this.profileForm.bill_payment_comp_code.trim() === '')) {
          cb(new Error('COMP CODE is required'));
        } else {
          cb();
        }
      },
      checkBillPaymentAccountNo(rule, value, cb) {
        if (this.profileForm.use_bill_payment_account_no &&
          (this.profileForm.bill_payment_account_no === null ||
            this.profileForm.bill_payment_account_no.trim() === '')) {
          cb(new Error('Account No. is required'));
        } else {
          // check account format
          const mask = createMask(this.mask.accountNo);
          const val = this.profileForm.bill_payment_account_no;
          if (val) {
            const resolvedValue = mask.resolve(val.toString());
            if (this.profileForm.use_bill_payment_account_no && resolvedValue.length !== 13) {
              cb(new Error('Account No. is not correct'));
            } else {
              cb();
            }
          } else {
            cb();
          }
        }
      },
      checkBillPaymentBillerId(rule, value, cb) {
        if (this.profileForm.use_bill_payment_biller_id) {
          let len = 0;
          if (value) {
            len = value.toString().length;
          }
          if (this.profileForm.bill_payment_biller_id === null ||
            this.profileForm.bill_payment_biller_id.trim() === '') {
            cb(new Error('Biller ID is required'));
          } else if (len !== 15) {
            cb(new Error('Biller ID must be 15 digits'));
          }
        }
        cb();
      },
      checkBarcodeQRCodeBillerId(rule, value, cb) {
        if (this.profileForm.barcode_qrcode_type === 'biller_id') {
          let len = 0;
          if (value) {
            len = value.toString().length;
          }
          if (this.profileForm.barcode_qrcode_biller_id_tax_id === null ||
            this.profileForm.barcode_qrcode_biller_id_tax_id.trim() === '') {
            cb(new Error('Biller ID is required'));
          } else if (len !== 13) {
            cb(new Error('Biller ID must be 13 digits'));
          } else if (this.profileForm.barcode_qrcode_biller_id_suffix === null ||
            this.profileForm.barcode_qrcode_biller_id_suffix.trim() === '') {
            cb(new Error('Biller ID Suffix is required'));
          } else if (this.profileForm.barcode_qrcode_biller_id_suffix &&
            this.profileForm.barcode_qrcode_biller_id_suffix.length !== 2) {
            cb(new Error('Biller ID Suffix must be 2 digits'));
          } else {
            cb();
          }
        } else {
          cb();
        }
      },
      checkBarcodeQRCodeAccountNo(rule, value, cb) {
        if (this.profileForm.barcode_qrcode_type === 'account_no') {
          if (this.profileForm.barcode_qrcode_account_no === null ||
            this.profileForm.barcode_qrcode_account_no.trim() === '') {
            cb(new Error('Account No. is required'));
          } else if (this.profileForm.barcode_qrcode_account_no_suffix === null ||
            this.profileForm.barcode_qrcode_account_no_suffix.trim() === '') {
            cb(new Error('Account No. Suffix is required'));
          } else if (this.profileForm.barcode_qrcode_account_no_suffix &&
            this.profileForm.barcode_qrcode_account_no_suffix.length !== 2) {
            cb(new Error('Account No. Suffix must be 2 digits'));
          } else {
            // check account format
            const mask = createMask(this.mask.accountNo);
            const val = this.profileForm.barcode_qrcode_account_no;
            if (val) {
              const resolvedValue = mask.resolve(val.toString());
              if (resolvedValue.length !== 13) {
                cb(new Error('Account No. is not correct'));
              } else {
                cb();
              }
            } else {
              cb();
            }
          }
        } else {
          cb();
        }
      },
      checkChargePayer() {
        if (this.profileForm.charge_payer) {
          this.$refs.profileForm.validateField('ir_br');
        }
      },
      checkIBIR(rule, value, cb) {
        if (this.profileForm.charge_payer && this.profileForm.ir_br.trim() === '') {
          cb(new Error('IB/IR is required'));
        } else {
          cb();
        }
      },
      checkNotificationMsg(rule, value, cb) {
        // check if custom message is select and not blank
        this.updateNotificationMsgValue();
        /* if (this.profileForm.notification_msg_type === 'CUSTOM' &&
          this.profileForm.notification_msg_custom.trim() === '') {
          cb(new Error('Custom Notification message is required'));
        } */
        cb();
      },
      businessTypeChange() {
        if (this.profileForm.business_type !== 'SPECIAL') {
          this.profileForm.business_type_special_industry = null;
        }
        this.$refs.profileForm.validateField('business_type_special_industry');
      },
      checkBusinessType(rule, value, cb) {
        let isValid = true;
        if (this.profileForm.business_type === 'SPECIAL') {
          if (this.profileForm.business_type_special_industry === null ||
            this.profileForm.business_type_special_industry.trim() === '') {
            isValid = false;
            cb(new Error('Business type special industry required'));
          }
        } else {
          this.profileForm.business_type_special_industry = null;
        }
        if (isValid) {
          cb();
        }
      },
      toggleUsingNotificationMsgValue() {
        // update notification_msg
        // this.updateNotificationMsgValue();
        if (this.profileForm.notification_msg_type === 'DATE') {
          this.profileForm.notification_msg_custom = '';
        }
        this.$refs.profileForm.validateField('notification_msg');
      },
      updateNotificationMsgValue() {
        if (this.profileForm.notification_msg_type === 'CUSTOM') {
          this.profileForm.notification_msg = this.profileForm.notification_msg_custom;
        } else {
          this.profileForm.notification_msg = `กรุณาชำระภายในวันที่ ${this.profileForm.notification_msg_date} ของทุกเดือน`;
        }
      },
      handleLogoSuccess(res) {
        this.isUploading = false;
        if (res.secure_url) {
          this.profileForm.logo = res.secure_url;
        }
      },
      handleLogoFail(res) {
        this.isUploading = false;
        let errorMessage = this.$t('Unexpected error');
        if (res) {
          errorMessage = res;
          if (res.error) {
            errorMessage = res.error;
            if (res.error.message) {
              errorMessage = res.error.message;
            }
          }
        }
        this.$store.dispatch('ADD_ERROR_FLASH', errorMessage);
      },
      beforeLogoUpload(file) {
        const isImage = ['image/jpeg', 'image/png', 'image/gif'].indexOf(file.type) !== -1;
        const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isImage) {
          this.$message.error('Logo picture must be JPG, PNG or GIF format!');
        }
        if (!isLt2M) {
          this.$message.error('Logo picture size can not exceed 2MB!');
        }
        return isImage && isLt2M;
      },
      handleHttpRequest(options) {
        this.isUploading = true;
        return this.$store.dispatch('UPLOAD_COMPANY_PROFILE_LOGO', options.file);
      },
      buildPayload() {
        const payload = JSON.parse(JSON.stringify(this.profileForm));
        // remove unnecessary key
        const stripKeys = [
          // 'use_company_address',
          'use_bill_payment_comp_code',
          'use_bill_payment_account_no',
          'use_bill_payment_biller_id',
          'barcode_qrcode_type',
          'notification_msg_type',
          'notification_msg_date',
          'notification_msg_custom',
          // 'other_banks',
        ];
        const makeNullKeys = [
          'bill_payment_comp_code',
          'bill_payment_account_no',
          'bill_payment_biller_id',
          'barcode_qrcode_biller_id_tax_id',
          'barcode_qrcode_biller_id_suffix',
          'barcode_qrcode_account_no',
          'barcode_qrcode_account_no_suffix',
          'notification_msg',
        ];
        Object.keys(payload).forEach((key) => {
          if (stripKeys.indexOf(key) !== -1) {
            delete payload[key];
          }
          if (key === 'use_company_address') {
            payload.use_company_address = payload.use_company_address || false;
          }
          // transform data before sending
          if (makeNullKeys.indexOf(key) !== -1) {
            if (payload[key] === '') {
              payload[key] = null;
            }
          }
        });
        if (!this.isUpdated) {
          delete payload.id;
        }
        // transform notification_msg
        if (payload.notification_msg) {
          payload.notification_msg = payload.notification_msg.replace(new XRegExp('[ ]{2,}', 'g'), ' ');
        }
        this.unmaskValue(payload, 'bill_payment_account_no', this.mask.accountNo);
        this.unmaskValue(payload, 'barcode_qrcode_account_no', this.mask.accountNo);
        return payload;
      },
      submitForm(formName) {
        this.$refs.profileForm.validateField('barcode_qrcode_biller_id_tax_id');
        this.$refs.profileForm.validateField('barcode_qrcode_account_no');
        this.$refs[formName].validate(this.validateForm);
      },
      validateForm(valid) {
        if (!valid) {
          this.$log.error('error submit!!');
          return false;
        }
        // build payload first
        this.updateNotificationMsgValue();
        this.isSubmitting = true;
        const action = this.isUpdated ? 'UPDATE_COMPANY_PROFILE_INFO' : 'CREATE_COMPANY_PROFILE_INFO';
        const payload = this.buildPayload();
        const reqPayload = {
          payload,
        };
        if (this.isUpdated) {
          reqPayload.profileId = payload.id;
        } else {
          reqPayload.companyId = this.companyId;
        }
        this.$store.dispatch(action, reqPayload).then(() => {
          this.isSubmitting = false;
          let successMessage = 'สร้างข้อมูลสำหรับรับชำระของบริษัทสำเร็จแล้ว';
          if (this.isUpdated) {
            successMessage = 'แก้ไขข้อมูลสำหรับรับชำระของบริษัทสำเร็จแล้ว';
          }
          this.$message({
            type: 'success',
            showClose: true,
            duration: 10000,
            message: successMessage,
          });
          this.$nextTick(() => {
            this.backToCompanyProfileList();
          });
        }).catch((msg) => {
          this.isSubmitting = false;
          if (msg) {
            this.$store.dispatch('ADD_ERROR_FLASH', this.$t(msg));
          } else {
            this.$store.dispatch('ADD_ERROR_FLASH', this.$t('Unexpected error'));
          }
        });
        return true;
      },
      confirmTerminate() {
        this.$confirm('ท่านกำลังจะลบข้อมูลบริษัทสำหรับรับชำระนี้ออกจากระบบ ท่านต้องการยืนยันเพื่อดำเนินการต่อหรือไม่?', 'ระวัง', {
          confirmButtonText: this.$t('Confirm'),
          confirmButtonClass: 'danger-btn',
          cancelButtonText: this.$t('Cancel'),
          type: 'warning',
        }).then(() => {
          this.isSubmitting = true;
          this.$store.dispatch('DELETE_COMPANY_PROFILE_INFO', this.profileId).then(() => {
            this.isSubmitting = false;
            this.$message({
              type: 'success',
              showClose: true,
              duration: 10000,
              message: 'ลบข้อมูลบริษัทสำหรับรับชำระสำเร็จแล้ว',
            });
            this.backToCompanyProfileList();
          }).catch((msg) => {
            this.isSubmitting = false;
            if (msg) {
              this.$store.dispatch('ADD_ERROR_FLASH', this.$t(msg));
            } else {
              this.$store.dispatch('ADD_ERROR_FLASH', this.$t('Unexpected error'));
            }
          });
        }).catch(() => {
        });
      },
      setupUpdateData() {
        this.isSetupUpdateData = true;
        Object.keys(this.profile).forEach((key) => {
          if (key === 'address') {
            // let isUseCompanyAddress = true;
            Object.keys(this.profile.address).forEach((addrKey) => {
              // check if the value for this profile & company are the same or not
              /* if (this.profile.address[addrKey] !== this.company.address[addrKey]) {
                isUseCompanyAddress = false;
              } */
              this.$set(this.profileForm.address, addrKey, this.profile.address[addrKey]);
            });
            // this.use_company_address = isUseCompanyAddress;
          } else if (key === 'notification_msg') {
            if (this.profile[key] === null) {
              this.$set(this.profileForm, key, '');
            } else {
              this.$set(this.profileForm, key, this.profile[key]);
            }
          } else if (key === 'other_banks') {
            // loop through array of other bank info
            this.profile[key].forEach((bankInfo) => {
              this.profileForm[key].push({
                account_name: bankInfo.account_name,
                account_number: bankInfo.account_number,
                account_logo: bankInfo.account_logo,
                comcode: bankInfo.comcode,
                service_fee: bankInfo.service_fee,
                service_code: bankInfo.service_code,
                branch_code: bankInfo.branch_code,
              });
            });
          } else {
            this.$set(this.profileForm, key, this.profile[key]);
          }
        });
        // update required control fields' value
        this.profileForm
          .use_bill_payment_comp_code = !!this.profileForm.bill_payment_comp_code;
        this.profileForm
          .use_bill_payment_account_no = !!this.profileForm.bill_payment_account_no;
        this.profileForm
          .use_bill_payment_biller_id = !!this.profileForm.bill_payment_biller_id;
        this.profileForm
          .barcode_qrcode_type = this.profileForm.barcode_qrcode_biller_id_tax_id ? 'biller_id' : 'account_no';
        this.profileForm.notification_msg_type = this.profileForm
          .notification_msg.indexOf('กรุณาชำระภายในวันที่') !== -1 &&
        this.profileForm.notification_msg.indexOf('ของทุกเดือน') !== -1 ? 'DATE' : 'CUSTOM';
        if (this.profileForm.notification_msg_type === 'DATE') {
          this.profileForm
            .notification_msg_date = this.profileForm.notification_msg
              .replace('กรุณาชำระภายในวันที่', '')
              .replace('ของทุกเดือน', '');
        } else {
          this.profileForm.notification_msg_custom = this.profileForm.notification_msg;
        }
        if (this.profileForm.business_type === '') {
          this.profileForm.business_type = 'B2C';
        }
        if (this.profileForm.business_type !== 'SPECIAL') {
          this.profileForm.business_type_special_industry = null;
        }
        this.updatePostCode();
        this.updateMaskAccountNo();
        this.updateMaskBillerId();
        // this.updateMaskIBIR();
      },
      clearUpdateData() {
        this.isSetupUpdateData = false;
        this.profileForm.id = null;
        this.profileForm.name = '';
        this.profileForm.use_company_address = true;
        this.profileForm.address.line_1 = '';
        this.profileForm.address.district = '';
        this.profileForm.address.city = '';
        this.profileForm.address.province = '';
        this.profileForm.address.postal_code = '';
        this.profileForm.address.tel = '';
        this.profileForm.address.fax = '';
        this.profileForm.use_bill_payment_comp_code = false;
        this.profileForm.bill_payment_comp_code = '';
        this.profileForm.use_bill_payment_account_no = false;
        this.profileForm.bill_payment_account_no = '';
        this.profileForm.use_bill_payment_biller_id = true;
        this.profileForm.bill_payment_biller_id = '';
        this.profileForm.barcode_qrcode_type = 'biller_id';
        this.profileForm.barcode_qrcode_biller_id_tax_id = '';
        this.profileForm.barcode_qrcode_biller_id_suffix = '';
        this.profileForm.barcode_qrcode_account_no = '';
        this.profileForm.barcode_qrcode_account_no_suffix = '';
        this.profileForm.payment_type = 'CHEQUE_OR_CASH';
        this.profileForm.charge_payer = false;
        this.profileForm.ir_br = '';
        this.profileForm.account_name = '';
        this.profileForm.label_ref1 = '';
        this.profileForm.label_ref2 = '';
        this.profileForm.label_ref3 = '';
        this.profileForm.allow_other_banks = true;
        this.profileForm.is_banking_agent = false;
        this.profileForm.other_banks.splice(0);
        this.profileForm.notification_msg_type = 'CUSTOM';
        this.profileForm.notification_msg_date = '1';
        this.profileForm.notification_msg_custom = '';
        this.profileForm.notification_msg = '';
        this.profileForm.logo = '';
        this.profileForm.printing_option = 'COLOR';
      },
      /* updateMaskTel() {
        this.maskValue(this.profileForm.address, 'tel', {
          mask: this.mask.telMask,
        });
      },
      updateMaskFax() {
        this.maskValue(this.profileForm.address, 'fax', {
          mask: this.mask.faxMask,
        });
      }, */
      updatePostCode() {
        try {
          this.maskValue(this.profileForm.address, 'postal_code', this.mask.postcode);
        } catch (e) {
          console.error(e);
        }
      },
      /* updateMaskIBIR() {
        this.maskValue(this.profileForm, 'ir_br', this.mask.ibirMask);
      }, */
      updateMaskCompCode() {
        this.maskValue(this.profileForm, 'bill_payment_comp_code', this.mask.compCode);
      },
      updateMaskAccountNo() {
        this.maskValue(this.profileForm, 'bill_payment_account_no', this.mask.accountNo);
        this.maskValue(this.profileForm, 'barcode_qrcode_account_no', this.mask.accountNo);
      },
      updateMaskBillerId() {
        this.maskValue(this.profileForm, 'bill_payment_biller_id', this.mask.billerId);
        this.maskValue(this.profileForm, 'barcode_qrcode_biller_id_tax_id', this.mask.qrBillerId);
      },
      maskValue(form, field, maskOptions) {
        const mask = createMask(maskOptions);
        const val = form[field];
        if (val) {
          const resolvedValue = mask.resolve(val.toString());
          form[field] = resolvedValue;
        }
      },
      unmaskValue(form, field, maskOptions) {
        const mask = createMask(maskOptions);
        const val = form[field];
        if (val) {
          mask.resolve(val.toString());
          form[field] = mask.unmaskedValue;
        }
      },
      /* eslint prefer-arrow-callback: 0 */
      handleInput: _.debounce(function handleInputFn(evt, refName, maskName) {
        helpers.handleInput(evt,
          this.$refs, refName,
          this.mask, maskName);
      }, process.env.HANDLE_INPUT_DEBOUNCE_INTERVAL, { tailing: true }),
      isBBLBank(accountName) {
        const testString = accountName.toLowerCase();
        const isBBL = testString.indexOf('bbl') !== -1 ||
          testString.indexOf('bangkok') !== -1 ||
          testString.indexOf('กรุงเทพ') !== -1;
        return isBBL;
      },
      getOtherBankInfoSummaryText(bankInfo) {
        let bankInfoText = `${bankInfo.account_name} A/C : ${bankInfo.account_number} / COMP CODE: ${bankInfo.comcode}`;
        if (this.isBBLBank(bankInfo.account_name)) {
          bankInfoText += ` / SERVICE CODE: ${bankInfo.service_code} / BR CODE: ${bankInfo.branch_code}`;
        }
        bankInfoText += ` / FEE : ${bankInfo.service_fee}`
        return bankInfoText;
      },
    },
    mounted() {
      // clear list
      this.dayList.splice(0);
      // populate day list
      for (let d = 1; d <= 31; d += 1) {
        this.dayList.push(d);
      }
      if (this.isUpdated) {
        setTimeout(() => {
          if (typeof this.profile === 'undefined' || this.profile === null) {
            this.backToCompanyProfileList();
          }
        }, 1000);
        if (this.profile) {
          this.setupUpdateData();
        }
      } else {
        // default to assign company's address for this profile automatically
        this.populateAddressFromCompany(true);
      }
    },
    watch: {
      profile(newVal) {
        if (this.isUpdated && !this.isSetupUpdateData && newVal) {
          this.setupUpdateData();
        }
      },
    },
    beforeRouteEnter(to, from, next) {
      next((vm) => {
        vm.$store.dispatch('SELECT_CURRENT_COMPANY', vm.companyId);
        vm.$store.dispatch('SELECT_CURRENT_COMPANY_PROFILE', vm.profileId);
      });
    },
    beforeRouteLeave(to, from, next) {
      this.clearUpdateData();
      this.$store.dispatch('SELECT_CURRENT_COMPANY_PROFILE', '');
      next();
    },
  };
  export default CompanyProfileFormView;
</script>

<style lang="scss">
  @import '../../assets/styles/color';
  .profile-form {
    .el-select {
      width: 100%;
    }
    .cancel-btn, .terminate-btn {
      padding-top: 16px;
      padding-bottom: 16px;
    }
    .submit-button-group {
      float: right;
    }
    #profileForm\.notification_msg_type_1 {
      .el-radio__input {
        display: inline-block;
        line-height: 50px;
        float: left;
      }
      .el-radio__label {
        display: block;
        width: 500px;
        line-height: 50px;
        margin-left: 15px;
      }
    }
    #profileForm\.notification_msg_type_2 {
      .el-radio__label {
        display: none;
      }
    }
    .remark-red {
      color: red;
    }
    .other-bank-list {
      margin-bottom: 40px;

      .other-bank-info {
        clear: both;
        margin-bottom: 15px;
      }
      .other-bank-logo-holder {
        width: 40px;
        height: 40px;
        border: 1px solid #ccc;
        background: #efefef;
        display: inline-block;
        float: left;
        margin-right: 10px;

        img {
          max-width: 100%;
        }
      }
      .other-bank-text-holder {
        line-height: 40px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/company/company-profile-form.vue